import './Header.scss';
import React from 'react';
import headerLogo from '../../assets/img/headerLogo.svg';
import LanguageSelect from '../../components/header-components/LanguageSelect';
import { useState } from 'react';
import { Link, useMatch } from 'react-router-dom';
import HeaderMob from '../../components/header-components/HeaderMob';
import { whitelists } from '../../i18n';


function Header(props) {
  let defaultType ='';
 // const defaultType =  window.location.pathname.includes('employers') ? 'employers': 'freelance';
  if(window.location.pathname.includes('employers')){
     defaultType ='employers';
  }
  else if(window.location.pathname.includes('blog')){
     defaultType ='blog';
  }
  else {
     defaultType ='freelance';
  }

  const [curentType, setCurrentType] = useState(defaultType);
  const match = useMatch('/:lang/*');
  



  let lang = match && match.params ?
    (whitelists.includes(match.params.lang) ? match.params.lang : null) :
    null;
  const freelanceLink = lang ? `/${lang}` : '/';
  const employersLink = lang ? `/${lang}/employers` : '/employers/'
  const blogLink = lang ? `/${lang}/blog`: `/blog/`
  return (
    <>
    <div className="header-main-wrapper">
      <div className="header-content">
        <div className="header-item">
          <Link className={`${"nav-link"} ${curentType === 'freelance' ? 'active': ''}`} onClick={() => setCurrentType('freelance')} to={freelanceLink} ><img src={headerLogo} alt="logo" /></Link>
        </div>
        <div className="header-item">
          <ul>
            <li> <Link className={`${"nav-link"} ${curentType === 'freelance' ? 'active': ''}`} onClick={() => setCurrentType('freelance')} to={freelanceLink}>{props.t("header_link_freelance")}</Link> </li>
            <li> <Link className={`${"nav-link"} ${curentType === 'employers' ? 'active': ''}`} onClick={() => setCurrentType('employers')} to={employersLink} >{props.t("header_link_employers")}</Link></li>
            <li> <Link className={`${"nav-link"}  ${curentType === 'blog' ? 'active': ''}`} onClick={() => setCurrentType('blog')} to={blogLink} >{props.t("blog_link")}</Link></li>
          </ul>
        </div>
        <div className='header-phone'>
        <a href="tel:+48 718 808 505" className="binct-phone-number-1">+48 718 808 505</a>
        </div>
        <div className="header-item">
          <LanguageSelect lang={props.lang} onLanguageChange={(lange)=>props.changeLanguages(lange)}/>
        </div>
      </div>
    </div>
    <HeaderMob t={props.t} onLanguageChange={(lange)=>props.changeLanguages(lange)}/>

    </>
  );
}

export default Header;